import {Injectable} from '@angular/core';
import {Observable, of} from "rxjs";
import {Label} from "../../model/Label";
import {FormGeneratorService} from "../../components/common/fields/form-generator.service";
import {FieldDefinition} from "../../model/field-definition";

@Injectable({
  providedIn: 'root'
})
export class LabelFormGeneratorService implements FormGeneratorService {

  constructor() {
  }

  getQuestions(label: Label): Observable<FieldDefinition<any>[]> {
    const questions = [
      new FieldDefinition<string>({
        key: "name",
        label: 'Nom du label',
        type: 'text',
        value: label.name,
        required: true,
        order: 1
      }),
      new FieldDefinition<string>({
        key: "backcolor",
        label: 'Couleur du fond',
        type: 'color-picker',
        value: label.backcolor,
        required: true,
        fullsize: false,
        order: 2
      }),
      new FieldDefinition<string>({
        key: 'textcolor',
        label: 'Couleur du texte',
        type: 'color-picker',
        value: label.textcolor,
        required: true,
        fullsize: false,
        order: 3
      }),
    ];
    return of(questions.sort((a, b) => a.order - b.order));
  }
}
